import styled from 'styled-components';
import { Card, CardHeader, StepNumber, Optional, Input, Hint, color } from '../App.styles';
import { isWideField } from '../minutes';

function InfoCard({ fields, info, fromTemplate, onChange }) {
  return (
    <Card>
      <CardHeader>
        <StepNumber>2</StepNumber>
        <h2>회의 정보</h2>
        <Optional>{fromTemplate ? '선택 입력 · 내 템플릿 항목' : '선택 입력'}</Optional>
      </CardHeader>

      {fields.length === 0 ? (
        <Hint>올린 양식에는 회의 정보 항목이 없습니다. 회의 내용만 정리합니다.</Hint>
      ) : (
        <>
          <FieldGrid>
            {fields.map(({ key, label, placeholder }) => (
              <Field key={key} $wide={isWideField(label)}>
                <span>{label}</span>
                <Input
                  value={info[key] || ''}
                  placeholder={placeholder || '비워 두면 회의 기록에서 찾아 채웁니다'}
                  onChange={(e) => onChange(key, e.target.value)}
                />
              </Field>
            ))}
          </FieldGrid>
          <Hint>비워 두면 회의 기록에서 찾아 채우고, 찾지 못한 항목은 "-"로 둡니다.</Hint>
        </>
      )}
    </Card>
  );
}

const FieldGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
`;

const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: 6px;
  grid-column: ${(props) => (props.$wide ? '1 / -1' : 'auto')};

  span {
    font-size: 13px;
    font-weight: 500;
    color: ${color.textSub};
  }
`;

export default InfoCard;
